import { Component, Input } from '@angular/core';
import { CardComponent } from '@legacy/common-ui-partials';

@Component({
  selector: 'wl-cookie-settings-category',
  templateUrl: './cookie-settings-category.component.html',
  styles: [':host{ display: block; }'],
  standalone: true,
  imports: [CardComponent],
})
export class CookieSettingsCategoryComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) title!: string;
}
